import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module';

import { App } from './app/app';

const tagManagerArgs = {
  gtmId: 'GTM-M5P9T92',
};

TagManager.initialize(tagManagerArgs);

const container = document.getElementById('root');

const root = createRoot(container!);

root.render(
  // <StrictMode>
  <App />,
  // </StrictMode>,
);

// I'm doing this exactly as is recommended in the React documentation:
// https://react.dev/reference/react/StrictMode
/* This is how main.tsx was prior to this epic:
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom';
import TagManager from 'react-gtm-module';

import { App } from './app/app';
import React from 'react';

const tagManagerArgs = {
  gtmId: 'GTM-M5P9T92',
};
// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById('root'),
);

*/
